export default class LocationHelper {
  static formatApiPriceIntoLocationCurrency (location, number) {
    return (number / 100).toLocaleString(location.locale, { style: 'currency', currency: location.currency });
  }
}
